import { POPUP_ACTION_TYPE } from 'store/global/actions';

const initialState = {
  isActive: false,
};

const popupReducer = function (state = initialState, { type }) {
  switch (type) {
    case POPUP_ACTION_TYPE.OPEN:
      return { ...state, isActive: true };

    case POPUP_ACTION_TYPE.CLOSE:
      return { ...state, isActive: false };

    default:
      return state;
  }
};

export default popupReducer;
